import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { app } from './config';

export const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Configure provider settings
googleProvider.setCustomParameters({
  prompt: 'select_account',
});
